export default __webpack_public_path__ + "static/media/marketplace.d290162a.svg";